var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5359 15.2383V25.0172",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0006 16.0156L10.1532 25.018",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7216 15.2383H28.4738C30.5447 15.2383 32.558 15.8998 34.2837 17.1653L44.3502 24.4707C44.8679 24.8446 45.4431 25.0747 46.0183 25.1897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2521 15.2383H22.7234",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0199 25.1895L52.3474 26.2824C54.447 26.6275 56.4603 27.7492 57.697 29.6475C58.3873 30.7117 58.7612 31.8333 58.7612 33.0701V33.8466C58.7612 36.2914 56.9492 38.2759 54.7058 38.2759H50.4779M38.4468 38.2759H28.7342H21.5522M9.86672 38.2759H5.29365C3.05025 38.2472 1.23828 36.2626 1.23828 33.8179V31.1431",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23828 31.1434C1.23828 31.1434 1.81351 15.2383 16.2518 15.2383",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56335 25.0176L46.0219 25.1902",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6203 43.9987C18.7972 43.9987 21.3726 41.4233 21.3726 38.2464C21.3726 35.0695 18.7972 32.4941 15.6203 32.4941C12.4434 32.4941 9.86804 35.0695 9.86804 38.2464C9.86804 41.4233 12.4434 43.9987 15.6203 43.9987Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3812 44.0007C47.5581 44.0007 50.1335 41.4253 50.1335 38.2484C50.1335 35.0715 47.5581 32.4961 44.3812 32.4961C41.2043 32.4961 38.6289 35.0715 38.6289 38.2484C38.6289 41.4253 41.2043 44.0007 44.3812 44.0007Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.d1f1915fc298996912986253cd9ffb4e.svg";
export { ForwardRef as ReactComponent };